import makeYearsOptions from '../../../Lib/Utils/Select/make-years-options';
import Joi from '../../../Lib/Utils/Joi';
import ProductionFacilityProfile from './ProductionFacilityProfile';
import GarmentProduction from './GarmentProduction';

export default {
  pageTitle: 'Factory Profiles',
  cards: [
    {
      title: 'Factories we work with',
      fields: [
        {
          label:
            'You must create an individual profile for each factory you work with. Click add a factory to add profiles.',
          buttonText: 'Add a factory',
          name: 'factories',
          min: 1,
          type: 'subForm',
          deleteConfirmation: {
            title: 'ARE YOU SURE YOU WANT TO DELETE THIS FACTORY?',
            text: 'All of your data will be deleted and this action cannot be undone.',
          },
          idKey: 'factoryName',
          subForm: [
            {
              pageTitle: 'Factory Profile Details',
              cards: [
                {
                  title: 'Details',
                  fields: [
                    {
                      label: 'Factory Name',
                      name: 'factoryName',
                      required: true,
                      type: 'text',
                    },
                    {
                      label: 'Phone Number',
                      name: 'phoneNumber',
                      required: true,
                      type: 'text',
                      specialValidation: Joi.string()
                        .phoneNumber()
                        .vpPhoneNumber()
                        .required(),
                    },
                    {
                      label: 'Year Business Established',
                      name: 'yearBusinessEstablished',
                      required: true,
                      type: 'select',
                      options: makeYearsOptions({
                        endYear: new Date().getFullYear(),
                        numberOfYears: 100,
                      }),
                    },
                    {
                      label: 'Do you have financial interest in the factory?',
                      name: 'financialInterest',
                      required: true,
                      type: 'yes_no',
                    },
                  ],
                },
                {
                  title: 'Location',
                  fields: [
                    {
                      label: 'Search your address',
                      name: 'searchAddress',
                      type: 'address',
                      required: true,
                      names: {
                        country: 'country',
                        addressLine1: 'addressLine1',
                        addressLine2: 'addressLine2',
                        postalCode: 'postalZipCode',
                        city: 'city',
                        state: 'stateProvince',
                      },
                    },
                  ],
                },
                {
                  title: 'Key Contact',
                  fields: [
                    {
                      label: 'Full Name',
                      name: 'contact.fullName',
                      required: true,
                      type: 'text',
                      specialValidation: Joi.string().vpFullName(),
                    },
                    {
                      label: 'Title',
                      name: 'contact.title',
                      type: 'text',
                    },
                    {
                      label: 'Email Address',
                      name: 'contact.emailAddress',
                      required: true,
                      type: 'text',
                      specialValidation: Joi.string().email({
                        tlds: { allow: false },
                      }),
                    },
                    {
                      label: 'Phone Number',
                      name: 'contact.phoneNumber',
                      required: true,
                      type: 'text',
                      specialValidation: Joi.string()
                        .phoneNumber()
                        .vpPhoneNumber()
                        .required(),
                    },
                  ],
                },
                {
                  title: 'Additional Info',
                  fields: [
                    {
                      label: 'Category Expertise',
                      name: 'categoryExpertise',
                      required: true,
                      type: 'text',
                    },
                    {
                      label:
                        'Are you capable of shipping DDP to Los Angeles, California, USA',
                      name: 'capableOfShipping',
                      required: true,
                      type: 'yes_no',
                    },
                  ],
                },
              ],
            },
            {
              pageTitle: 'Production Facilities',
              cards: [
                {
                  title: 'Production Facilities We Work With',
                  fields: [
                    {
                      label:
                        'You must create an individual profile for each production facility you work with.' +
                        ' If you have nothing to add you can skip this step.' +
                        ' Each factory utilized by the vendor for Fashion Nova production must be listed.',
                      buttonText: 'Add a production facility',
                      type: 'subForm',
                      name: 'productionFacilities',
                      min: 0,
                      idKey: 'factoryName',
                      subForm: [ProductionFacilityProfile, GarmentProduction],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
